'use client'
import {
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/client.ts
import { GraphQLClient } from "graphql-request";

// src/config.ts
var CalendarApiConfig = class {
  constructor() {
    this._config = null;
  }
  get config() {
    return this._config;
  }
  init(config) {
    this._config = this.setConfig(config);
    this.configClient(this._config);
  }
  update(config) {
    this._config = this.setConfig(config);
    this.configClient(this._config);
  }
  /**
   * Set the config object with defaults
   */
  setConfig(config) {
    return __spreadValues(__spreadValues({}, this._config), config);
  }
  configClient(config) {
    gqlClient.setEndpoint(config.api.cmsBase);
    gqlClient.requestConfig.method = "POST";
  }
};
var CalendarConfig = new CalendarApiConfig();

// src/api/client.ts
var gqlClient = new GraphQLClient("");
gqlClient.requestConfig.requestMiddleware = (req) => {
  if (!CalendarConfig.config) {
    const msg = "WBK `CalendarConfig` was not initialized. See instructions in https://github.com/nadude/webook-frontend/blob/main/packages/calemdar/README.md";
    throw new Error(msg);
  }
  return req;
};

export {
  gqlClient,
  CalendarConfig
};
//# sourceMappingURL=chunk-6XSQRWIQ.mjs.map